<template>
    <div>
        <div v-if="!loaded" class="loading" :class="{ fade_out: !loading }">
            <em v-if="loading"></em>
        </div>
        <div class="main" ref="main">
            <PageSwiper v-bind:height="height" v-bind:page="page" v-bind:callback="callback">
                <section class="s1">
                    <div class="m">
                        <div class="bg">
                            <div class="logo"></div>
                            <div class="topbg1"></div>
                            <div class="title_1"></div>
                            <p>懐かしい学校生活に戻って、<br />学校知識をチャレンジしよう！</p>
                        </div>
                        <div
                            @click="start()"
                            class="next_btn jstracker"
                            param="{'action':'click_challenge'}"
                        >
                            <div class="btn_inner">チャレンジ <i></i></div>
                        </div>
                    </div>
                </section>
                <section class="s2">
                    <div class="m">
                        <div class="bg">
                            <div class="logo"></div>
                            <div class="topbg2"></div>
                            <div class="title_2"></div>
                        </div>
                        <div class="chosen_btns">
                            <div
                                class="next_btn jstracker"
                                param="{'action':'click_chooselevel'}"
                                @click="go_to_page(3, 1)"
                            >
                                <div class="btn_inner">簡単レベル <i></i></div>
                            </div>
                            <div
                                class="next_btn jstracker"
                                param="{'action':'click_chooselevel'}"
                                @click="go_to_page(3, 2)"
                            >
                                <div class="btn_inner">一般レベル <i></i></div>
                            </div>
                            <div
                                class="next_btn jstracker"
                                param="{'action':'click_chooselevel'}"
                                @click="go_to_page(3, 3)"
                            >
                                <div class="btn_inner">困難レベル <i></i></div>
                            </div>
                        </div>
                    </div>
                </section>
                <template v-if="this_q.length">
                    <template v-for="n in 5">
                        <section :key="n" v-bind:class="['s' + (2 + n)]">
                            <div class="m">
                                <div class="bg">
                                    <div class="topbg3"></div>
                                </div>
                                <div class="question_container">
                                    <div class="num">0{{ n }}</div>
                                    <p class="q_font" v-html="this_q[n - 1].title"></p>
                                    <div class="option_btns">
                                        <div
                                            class="option_btn jstracker"
                                            :param="`{'action':'click_p${n + 2}choose'}`"
                                            v-bind:class="{ blue: correct === 3 * n - 2 }"
                                            @click="
                                                go_to_page(3 + n, 4);
                                                show_answer(this_q[n - 1].answer, 1, n, $event);
                                            "
                                        >
                                            <i></i> {{ this_q[n - 1].options[0] }}
                                        </div>
                                        <div
                                            class="option_btn jstracker"
                                            :param="`{'action':'click_p${n + 2}choose'}`"
                                            v-bind:class="{ blue: correct === 3 * n - 1 }"
                                            @click="
                                                go_to_page(3 + n, 4);
                                                show_answer(this_q[n - 1].answer, 2, n, $event);
                                            "
                                        >
                                            <i></i> {{ this_q[n - 1].options[1] }}
                                        </div>
                                        <div
                                            class="option_btn jstracker"
                                            :param="`{'action':'click_p${n + 2}choose'}`"
                                            v-bind:class="{ blue: correct === 3 * n }"
                                            @click="
                                                go_to_page(3 + n, 4);
                                                show_answer(this_q[n - 1].answer, 3, n, $event);
                                            "
                                        >
                                            <i></i> {{ this_q[n - 1].options[2] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </template>
                </template>
                <section class="s8" id="last_node" :class="{ fade_in: fade_in }">
                    <div class="m">
                        <div class="bg">
                            <div
                                class="repeat_btn jstracker"
                                param="{'action':'click_oncemore'}"
                                @click="replay()"
                            ><i></i>もう一回</div>
                            <a
                                class="tw jstracker"
                                href="https://twitter.com/dokidoki_live"
                                param="{'action':'click_giftget'}"
                            ></a>
                            <div class="topbg1"></div>
                            <div class="result_bg">
                                <div>
                                    <p class="score">あなたは{{ score }}点を獲得した!</p>
                                    <div class="result_text">
                                        {{ result[difficult * 1000 + score] }}
                                    </div>
                                </div>
                                <div class="stamp"></div>
                            </div>
                        </div>
                        <a
                            class="next_btn jstracker"
                            param="{'action':'click_sharetwitter'}"
                            @click="share()"
                        >
                            <div class="btn_inner">Twitterにシェア <i></i></div>
                        </a>
                    </div>
                </section>
            </PageSwiper>
        </div>
        <div v-if="pop">
            <div
                class="shade jstracker"
                @click="close()"
                param="{'action':'click_windowclose'}"
            ></div>
            <div class="pop">
                <i @click="close()" class="jstracker" param="{'action':'click_windowclose'}"></i>
                <h3>面白かったら友達にもシェアしてみよう!</h3>
                <div class="result">
                    <img :src="share_img" alt="" />
                </div>
                <a
                    class="next_btn jstracker"
                    param="{'action':'click_windowshare'}"
                    @click="share()"
                >
                    <div class="btn_inner">Twitterにシェア</div>
                </a>
            </div>
        </div>
        <div
            v-if="page === 8 && !inapp"
            class="adv jstracker"
            param='{action:"click_banner"}'
            id="adv"
        >
            <a href="https://goo.gl/jZmH8H">
                <img src="../../assets/banner.png" alt="" />
            </a>
        </div>
    </div>
</template>
<script type="es6">
import PageSwiper from '../../../common/components/PageSwiper';
import { QUESTION, RESULT } from '../../constants/QUESTION';

const { util: { getUrlStrs, shareTwitter } } = require('../../../common/module/util');
const { bridge } = require('../../../common/module/bridge');
const { Tracker } = require('../../../common/module/Tracker');
const { request } = require('../../../common/module/request');

let params = getUrlStrs();
let timer, startTimer, tracker;

export default {
    name: 'App',
    data: () => {
        return {
            loading: true,
            loaded: false,
            height: 0,
            pop: false,
            inapp: params.v,
            fade_in: false,
            page: 1,
            login: false,
            score: 0,
            random: 1,
            result: RESULT,
            correct: 0,
            difficult: 1, //题目难度,
            this_q: QUESTION[1] //默认选中的题库
        };
    },

    computed: {
        share_img: function () {
            return "https://rescdn.dokidokilive.com/festatic/fe/doki/image/wei/20190507/" + (this.difficult * 1000 + this.score) + ".png";
        }
    },

    components: {
        PageSwiper
    },

    methods: {
        go_to_page: function (page, num) {
            let self = this;
            if (num && num < 4) {
                let rand = Math.floor(Math.random() * 3) + 1 + (num - 1) * 3;
                //排除刷新后和上次一样的题目
                if (self.difficult === num) {
                    while (rand === self.random) {
                        rand = Math.floor(Math.random() * 3) + 1 + (num - 1) * 3;
                    }
                }
                self.random = rand;
                self.difficult = num;
                self.this_q = QUESTION[rand];
            }
            setTimeout(function () {
                self.page = page;
            }, 500);
        },
        start: function () {
            let self = this;
            if (startTimer) {
                clearTimeout(startTimer);
            }
            self.go_to_page(2, 0);
        },
        // 最后一页淡出效果，4s后展示弹窗提示分享
        callback: function () {
            let self = this;
            if (this.page === 8) {
                self.fade_in = true;
                timer = setTimeout(function () {
                    self.pop = true;
                }, 4000);
            }
        },
        show_answer: function (num_1, num_2, num_3, e) {
            let self = this;

            if (num_1 === num_2) {
                self.score = self.score + 20;
            } else {
                // 如果选中错误，则显示错误的样式
                e.target.classList.add("yellow");
                // 展示完成并切换走的页面，移除错误样式，避免再玩一次时展示
                setTimeout(() => {
                    e && e.target && e.target.classList.remove("yellow");
                }, 500);
            }
            self.correct = (num_3 - 1) * 3 + num_1;
        },
        // 再玩一次，清除上一次的成绩和正确答案记录
        replay: function () {
            let self = this;
            // 再玩一次时清除弹窗定时器
            if (timer) {
                clearTimeout(timer);
            }
            self.go_to_page(2, 5);
            // 对应切屏时间，避免当前展示文案变更
            setTimeout(function () {
                self.score = 0;
                self.correct = 0;
            }, 500);
        },
        close: function () {
            this.pop = false;
        },
        share: function () {
            let self = this;
            let num = self.difficult * 1000 + self.score;
            let share_obj = {
                title: "",
                content: "懐かしい学校生活に戻り、知識検定を受けましょう！#ドキドキLIVE #青春 #学校 #頭脳王 #知識検定 #プレゼント企画",
                url: "https://www.doki.live/share?from=17&variable=" + num,
                image_url: "https://rescdn.dokidokilive.com/festatic/fe/doki/image/wei/20190507/" + num + ".png"
            };
            shareTwitter(share_obj, self.login);
        }
    },

    mounted: function () {
        tracker = new Tracker('Doki school knowledge', 'enter_h5');
        const self = this;

        request({
            method: "get",
            url: "/api/user/uid/",
            callback: function (data) {
                if (data.err_code == 0) {
                    if (data.data.uid) {
                        self.login = true;
                    }
                }
            }
        });

        window.ontouchmove = () => {
            return false;
        };
        window.addEventListener("load", () => {
            self.loading = false;
            setTimeout(function () {
                self.loaded = true;
            }, 2000);
        });
        self.height = self.$refs.main.offsetHeight;
        startTimer = setTimeout(function () {
            self.go_to_page(2, 0);
            tracker.track('start_jump');
        }, 3000);
    }
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../../../common/sass/basic/_common.scss';
@import '../../../common/sass/basic/_mixin.scss';

@import './app.scss';
</style>
